import React, { useState, useEffect } from "react";
import axios from "axios";
import { URL } from "../../../api/tklEnvironments";

interface FAQItem {
  id?: number;
  question: string;
  answer: string;
  category?: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [faqData, setFaqData] = useState<FAQItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(`${URL}/faqs`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        });
        
        // Get only the first 2 items from the database
        const faqs = response.data.data || [];
        setFaqData(faqs.slice(0, 2));
      } catch (error) {
        console.error('Error fetching FAQs:', error);
        // Fallback to empty array if API fails
        setFaqData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: 0,
        gap: 24,
        width: "100%",
      }}
    >
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 600,
          fontSize: 24,
          lineHeight: "29px",
          color: "#000",
          marginBottom: 8,
          width: "100%",
        }}
      >
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 24 }}>
        {loading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem",
            color: "#666",
          }}>
            Loading FAQs...
          </div>
        ) : faqData.length === 0 ? (
          <div style={{
            textAlign: "center",
            padding: "2rem",
            color: "#666",
            border: "1px dashed #ddd",
            borderRadius: "16px",
            width: "100%",
          }}>
            No FAQs available at this time.
          </div>
        ) : (
          faqData.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={idx}
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: 16,
                gap: 13,
                width: "100%",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(0,0,0,0.11)",
                borderRadius: 32,
                transition: "box-shadow 0.2s",
                boxShadow: isOpen ? "0 2px 12px rgba(24,153,142,0.08)" : undefined,
                cursor: "pointer",
              }}
              onClick={() => setOpenIndex(isOpen ? null : idx)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  gap: 13,
                }}
              >
                <span
                  style={{
                    fontFamily: "Poppins, Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: 22,
                    lineHeight: "33px",
                    color: "#18998E",
                    flex: 1,
                  }}
                >
                  {item.question}
                </span>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    background: "#18998E",
                    border: "3px solid #40DCCF",
                    borderRadius: "100px",
                    transform: isOpen ? "rotate(0deg)" : "rotate(-180deg)",
                    transition: "transform 0.2s",
                  }}
                >
                  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9L9 1L17 9" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </div>
              {isOpen && (
                <div
                  style={{
                    fontFamily: "Poppins, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: "24px",
                    color: "#737373",
                    marginTop: 4,
                    width: "100%",
                  }}
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              )}
            </div>
          );
        })
        )}
      </div>
    </div>
  );
};

export default FAQ; 
